import React from "react";
import "./Services.css";
import headingImg from "../../assets/img/heading-img.png";
import servicesImg from "../../assets/img/services.jpg";
import service1 from "../../assets/img/service-icon-1.png";
import service2 from "../../assets/img/service-icon-2.png";
import service3 from "../../assets/img/service-icon-3.png";
import service4 from "../../assets/img/service-icon-4.png";

const Services = () => {
  return (
    <div id="services">
      <section class="gap">
        <div className="container">
          <div className="heading">
            <img src={headingImg} alt="icon" />
            <p>Serving Humanity</p>
            <h2>Our Services</h2>
          </div>
          <div className="row align-items-center">
            <div className="col-lg-3">
              <div className="service">
                <img src={service1} alt="img" />
                <a href="#">Event Booking</a>
                <p>
                  Lorem ipsum dolor sit amet, cons mod tempor incididunt ut labo
                  e minim veniam.
                </p>
              </div>
              <div className="service">
                <img src={service2} alt="img" />
                <a href="#">Islamic Marriage</a>
                <p>
                  Lorem ipsum dolor sit amet, cons mod tempor incididunt ut labo
                  e minim veniam.
                </p>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="video position-relative">
                <a
                  data-fancybox=""
                  href="https://www.youtube.com/watch?v=xKxrkht7CpY"
                >
                  <i>
                    <svg
                      width="11"
                      height="17"
                      viewBox="0 0 11 17"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 8.49951L0.5 0.27227L0.5 16.7268L11 8.49951Z"
                        fill="#000"
                      ></path>
                    </svg>
                  </i>
                </a>
                <img src={servicesImg} alt="img" />
              </div>
            </div>
            <div className="col-lg-3">
              <div className="service">
                <img src={service3} alt="img" />
                <a href="#">Islam Education</a>
                <p>
                  Lorem ipsum dolor sit amet, cons mod tempor incididunt ut labo
                  e minim veniam.
                </p>
              </div>
              <div className="service">
                <img src={service4} alt="img" />
                <a href="#">Funeral Prayer</a>
                <p>
                  Lorem ipsum dolor sit amet, cons mod tempor incididunt ut labo
                  e minim veniam.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
